import PropTypes from "prop-types";
import { ErrorMessage } from "../error-message";
import styles from "./styles";
import classnames from "classnames";

export const RadioButtonGroup = ({
  label,
  options,
  selectedValue,
  onSelect,
  name,
  id,
  errorMessage,
  required,
}) => {
  return (
    <>
      <fieldset
        id={id}
        className={styles.wrapper}
        role="radiogroup"
        aria-required={required}
      >
        {label && <legend className="app_london3">{label}</legend>}
        {options.map((option) => (
          <div
            className={classnames(
              styles.item,
              option.value === selectedValue && styles.selected
            )}
            key={`#${name}_${option.value}`}
          >
            <label
              htmlFor={`#${name}_${option.value}`}
              className={`app_london3 ${styles.itemLabel}`}
            >
              {option.label}
            </label>
            <input
              type="radio"
              name={option.label}
              value={option.value}
              id={`#${name}_${option.value}`}
              checked={option.value === selectedValue}
              aria-checked={option.value === selectedValue}
              onChange={() => onSelect(option.value)}
            />
          </div>
        ))}
      </fieldset>
      {errorMessage && <ErrorMessage message={errorMessage} />}
    </>
  );
};

RadioButtonGroup.propTypes = {
  label: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
    })
  ).isRequired,
  selectedValue: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  errorMessage: PropTypes.string,
  required: PropTypes.bool,
};

RadioButtonGroup.defaultProps = {
  label: "",
  selectedValue: "",
  errorMessage: "",
  required: false,
};
